import React, { Component } from 'react';
import { Container, Grid, Menu, Icon, Image } from 'semantic-ui-react';
import _ from 'underscore';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { doLogoutUser } from '../../../actions';

import GroupCareLogoVerImage from './groupcare_logo_ver.jpg';
import {FAQ} from '../../../constants';

const ROOT_APPLICATION_URL = '/app';
    // const menuItems = [
    //     {
    //         label: 'Home',
    //         icon: 'home',
    //         url: ''
    //     },
    //     {
    //         label: 'Submit Claim',
    //         icon: 'upload',
    //         url: '/submitclaim'
    //     },
    //     {
    //         label: 'Claim Records',
    //         icon: 'folder outline',
    //         url: '/claimrecords'
    //     },
    //     {
    //         label: 'Request eLOG',
    //         icon: 'upload',
    //         url: '/submitelog'
    //     },
    //     {
    //         label: 'eLOG Records',
    //         icon: 'folder outline',
    //         url: '/elogrecords'
    //     },
    //     {
    //         label: 'Find Panel Clinics',
    //         icon: 'map marker alternate',
    //         url: '/cliniclocator'
    //     },
    //     {
    //         label: 'eCards',
    //         icon: 'id card outline',
    //         url: '/ecards'
    //     },
    //     {
    //         label: 'Rewards',
    //         icon: 'coffee',
    //         url: '/rewards'
    //     },
    //     {
    //         label: 'Store',
    //         icon: 'id card outline',
    //         url: '/store'
    //     },
    //     {
    //         label: 'Ask Joey',
    //         icon: 'chat',
    //         url: '/askjoey'
    //     },
    // {
    //     label: 'hr admin',
    //     icon: 'users',
    //     url: '/hradmin',
    // },
    // {
    //     label: 'rewards',
    //     icon: 'file text',
    //     url: '/app/rewards'
    // },
    // {
    //     label: 'store',
    //     icon: 'history',
    //     url: '/app/store'
    // },
    //     {
    //         label: 'Profile',
    //         icon: 'user',
    //         url: '/profile'
    //     },
    // ]


class NavSidebar extends Component {
    constructor(props) {
        super(props);
        this.menuItems2 = []
    }

    componentWillMount(){
        this.assignBenefitConfig()
    }

    assignBenefitConfig() {
        const userMemberType = this.props.user.companies.filter(company => company.memberType.toUpperCase() == 'E').length

        if (this.props.configBenefit && this.props.configBenefit.featuresConfig) {
            this.menuItems2.push({
                label: 'Home',
                icon: 'home',
                url: ''
            })
            if (userMemberType > 0){
                if (this.props.configBenefit.featuresConfig.allowEclaimSubmit) {
                    this.menuItems2.push({
                        label: 'My Authenticator',
                        icon: 'shield alternate',
                        url: '/authenticator'
                    })
                }

                if (this.props.configBenefit.featuresConfig.allowEclaimSubmit) {
                    this.menuItems2.push({
                        label: 'Submit Claim',
                        icon: 'upload',
                        url: '/submitclaim'
                    })
                    this.menuItems2.push({
                        label: 'Claim Records',
                        icon: 'folder outline',
                        url: '/claimrecords'
                    })
                }

                if (this.props.configBenefit.featuresConfig.allowMyVisit) {
                    this.menuItems2.push({
                        label: 'My Visits',
                        icon: 'folder outline',
                        url: '/visits'
                    })
                }

                if (this.props.configBenefit.featuresConfig.allowLOG) {
                    this.menuItems2.push({
                        label: 'Request eLOG',
                        icon: 'upload',
                        url: '/submitelog'
                    })
                    this.menuItems2.push({
                        label: 'eLOG Records',
                        icon: 'folder outline',
                        url: '/elogrecords'
                    })
                }
            }  
            if (this.props.configBenefit.featuresConfig.allowClinicLocator) {
                this.menuItems2.push({
                    label: 'Find Panel Clinics',
                    icon: 'map marker alternate',
                    url: '/cliniclocator'
                })
            }
            if (this.props.configBenefit.featuresConfig.allowEcard) {
                this.menuItems2.push({
                    label: 'eCards',
                    icon: 'id card outline',
                    url: '/ecards'
                })
            }
            if (this.props.configBenefit.featuresConfig.allowStretchMyDollar) {
                this.menuItems2.push({
                    label: 'Rewards',
                    icon: 'coffee',
                    url: '/rewards'
                })
            }
            if (this.props.configBenefit.featuresConfig.allowMarketplace) {
                this.menuItems2.push({
                    label: 'Store',
                    icon: 'shopping bag',
                    url: '/store'
                })
            }
            if (this.props.configBenefit.featuresConfig.allowChat) {
                this.menuItems2.push({
                    label: 'Ask Joey',
                    icon: 'chat',
                    url: '/askjoey'
                })
            }
            this.menuItems2.push({
                label: 'Profile',
                icon: 'user',
                url: '/profile'
            }) 
        }
    }

    renderMenuItems() {
        return _.map(this.menuItems2, ({label, icon, url}) => {
            let active = false;
            if (this.props.currentPath.indexOf(url) !== -1 && url !== '') {
                active = true;
            }
            if (url === '' && this.props.currentPath === '/app') {
                active = true;
            }
            let linkToUrl = `${ROOT_APPLICATION_URL}${url}`;
            if (label === 'hr admin') {
                linkToUrl = url;
            }
            return (
                <Link to={linkToUrl} key={label}>
                    <Menu.Item
                        key={label}
                        name={label}
                        active={active}
                        as='div'
                    >
                        <Icon name={icon} />
                        {label}
                    </Menu.Item>
                </Link>
            );
        });
    }
    
    render() {
        let userHasHradminAccess = false;
        if (this.props.assignedRoles) {
            const hasHradminAssignedData = _.find(this.props.assignedRoles, (role) => role.type === 'hradmin');
            if (hasHradminAssignedData) { userHasHradminAccess = true; }
        }
        return (
            <Container>
                <Grid>
                    <Grid.Row>
                        <Grid.Column>
                            <Image src={GroupCareLogoVerImage} fluid />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <Menu secondary vertical fluid>
                                {this.renderMenuItems()}
                                {/*{
                                    (userHasHradminAccess === true) ?
                                    (
                                        //<Link to="/hradmin" key="hradmin"> //added by JW
                                        <Link to="/" key="hradmin">
                                            <Menu.Item
                                                key="hradmin"
                                                name="hr admin"
                                                active={false}
                                                onClick={() => window.open(this.props.minsightsUrl, '_blank')} //[ADDED BY JW]
                                                style={{textTransform: 'capitalize'}}
                                                as='div'
                                            >
                                                <Icon name="users" />
                                                Hr Admin
                                            </Menu.Item>
                                        </Link>
                                    )
                                    :
                                    null
                                }*/} 
                                <Link to={FAQ} target='blank' key="faq">
                                    <Menu.Item
                                        key="faq"
                                        name="faq"
                                        active={false} 
                                        style={{textTransform: 'capitalize'}}
                                        as='div'
                                    >
                                        <Icon name="question circle" />
                                        FAQ
                                    </Menu.Item>
                                </Link>
                                <Link to="/" key="logout">
                                    <Menu.Item
                                        key="logout"
                                        name="logout"
                                        active={false}
                                        onClick={() => this.props.doLogoutUser(this.props.user.accessToken)}
                                        style={{textTransform: 'capitalize'}}
                                        as='div'
                                    >
                                        <Icon name="log out" />
                                        Log Out
                                    </Menu.Item>
                                </Link>
                            </Menu>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

export default connect(null, { doLogoutUser } )(NavSidebar);

/**
 * <Dropdown item text='Display Options'>
                    <Dropdown.Menu>
                        <Dropdown.Header>Text Size</Dropdown.Header>
                        <Dropdown.Item>Small</Dropdown.Item>
                        <Dropdown.Item>Medium</Dropdown.Item>
                        <Dropdown.Item>Large</Dropdown.Item>
                    </Dropdown.Menu>
                    </Dropdown>
 */
